<template>
  <KemudahanAsasBase :amenity="amenity" />
</template>

<script>
// Jenis Milikan Rumah (JMR) — Peratusan isi rumah mengikut jenis pemilikan tempat
// kediaman. Sub-kategori: Dimiliki / Disewa / Kuarters (rujuk Lampiran 1). All UI,
// filters and export live in KemudahanAsasBase; this page only supplies the config.
import KemudahanAsasBase from "./KemudahanAsasBase.vue";

export default {
  name: "JenisMilikanRumah",
  components: { KemudahanAsasBase },
  data() {
    return {
      amenity: {
        key: "jmr",
        endpoint: "getJenisMilikanRumahLampiran",
        icon: "mdi-home-account",
        title: "Jenis Milikan Rumah (JMR)",
        subtitle: "Peratusan isi rumah mengikut jenis pemilikan tempat kediaman, strata dan daerah pentadbiran",
        cardTitle: "Peratusan Isi Rumah mengikut Jenis Milikan Rumah",
        exportTitle: "PERATUSAN ISI RUMAH MENGIKUT JENIS PEMILIKAN TEMPAT KEDIAMAN",
        subCategories: ["Dimiliki", "Disewa", "Kuarters"],
        sheetName: "Jenis Milikan Rumah",
        fileSlug: "Peratusan_Isi_Rumah_Jenis_Milikan_Rumah",
      },
    };
  },
};
</script>
